// One open/close window on a single day of week. dayOfWeek follows JavaScript's
// Date.getDay() convention: 0 = Sunday, 1 = Monday, …, 6 = Saturday — matches
// the int the API stores in dbo.facility_schedule.
export interface FacilityScheduleEntry {
    id: number;
    dayOfWeek: number;
    openTime: string;   // "HH:mm"
    closeTime: string;  // "HH:mm"
}

export const DAY_OF_WEEK_LABELS: ReadonlyArray<{ value: number; label: string }> = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
];
